import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const StickyMobileCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-4 left-4 right-4 z-40 transition-all duration-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
    >
      <Link
        to="/bewerben"
        className="block w-full text-center bg-primary text-primary-foreground font-semibold text-base px-6 py-4 rounded-xl shadow-[0_10px_30px_hsl(227_78%_52%/0.4)] cta-pulse"
      >
        Jetzt bewerben
      </Link>
    </div>
  );
};

export default StickyMobileCTA;
